import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import './App.css';
import Provider from './context/Provider';
import Login from './pages/Login';
import Home from './pages/Home';
// import Reports from './pages/Reports';
import Header from './components/Header';
import Burger from './components/Burguer';
import Config from './pages/Config';
import CallCenter from './pages/Callcenter'
import CreateEndpoints from './components/Config/Endpoints/EndpointsCreate';
import ListEndpoints from './components/Config/Endpoints/EndpointsList';
import ListEndpointsById from './components/Config/Endpoints/EndpointsListById';
import CreateTrunks from './components/Config/Trunks/TrunksCreate';
import ListTrunks from './components/Config/Trunks/TrunksList';
import ListTrunksById from './components/Config/Trunks/TrunksListById';
import ChangeIp from './components/Config/System/ChangeIp';
import InterfacesList from './components/Config/System/InterfacesList';
import QueuesCreate from './components/Config/Queues/QueuesCreate';
import QueuesList from './components/Config/Queues/QueuesList';
import QueuesListById from './components/Config/Queues/QueuesListById';
import MembersQueuesCreate from './components/Config/Queues/MembersQueuesCreate';
import QueuesMembersList from './components/Config/Queues/QueuesMembersList';
import RoutesNewSet from './components/Config/System/RoutesNew';
import RoutesList from './components/Config/System/RoutesList';
import MemberQueuesById from './components/Config/Queues/components/MembersListById';
import DialPlanEntrance from './components/Config/DialPlan/DialPlanEntranceCalls';
import DialPlanInternal from './components/Config/DialPlan/DialPlanInternalCalls';
import DialPlanExternal from './components/Config/DialPlan/DialPlanExternalCalls';
import CreateUsers from './components/Config/Users/UserCreate';
import ListUsers from './components/Config/Users/UsersList';
import ListUserId from './components/Config/Users/components/UserById';
import ListContacts from './components/Contacts/ContactsList';
import NewContact from './components/Contacts/ContactsCreate';
import ContactById from './components/Contacts/ContactsListById';
import ContactShowById from './components/Contacts/ContactsShowById';
import LogsVigoscloud from './components/Events/LogsVigoscloud';
import PingPage from './components/Config/System/PingIp';
import Dashboard from './pages/Dashboard/index';
import Uploads from './components/Config/Uploads/UraAndMohUpdate';
import UploadsList from './components/Config/Uploads/UraAndMohList';
import Tenants from './components/Config/Tenant/TenantCreate';
import TenantsList from './components/Config/Tenant/TenantsList';
class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Provider>
          <div className="is-justify-content-end">
            <Header />
            <Burger />
            <Route exact path="/" component={ Login } />
            <Route exact path="/home" component={ Home } />
            {/* <Route exact path="/relatorios" component={ Reports } /> */}
            <Route exact path="/dashboard" component={ Dashboard } />
            <Route exact path="/callcenter" component={ CallCenter } />
            <Route exact path="/config" component={ Config } />
            <Route exact path="/config/ramal/novo" component={ CreateEndpoints } />
            <Route exact path="/config/ramal/lista" component={ ListEndpoints } />
            <Route exact path="/config/ramal/id" component={ ListEndpointsById } />
            <Route exact path="/config/tronco/novo" component={ CreateTrunks } />
            <Route exact path="/config/tronco/lista" component={ ListTrunks } />
            <Route exact path="/config/tronco/id" component={ ListTrunksById } />
            <Route exact path="/config/rede/ip" component={ ChangeIp } />
            <Route exact path="/config/rede/ip/lista" component={ InterfacesList } />
            <Route exact path="/config/rede/ip/routes" component={ RoutesNewSet } />
            <Route exact path="/config/rede/ip/routes/lista" component={ RoutesList } />
            <Route exact path="/config/fila/nova" component={ QueuesCreate } />
            <Route exact path="/config/fila/lista" component={ QueuesList } />
            <Route exact path="/config/fila/lista/nome" component={ QueuesListById } />
            <Route exact path="/config/fila/membros/novo" component={ MembersQueuesCreate } />
            <Route exact path="/config/fila/membros/lista" component={ QueuesMembersList } />
            <Route exact path="/config/fila/membros/lista/id" component={ MemberQueuesById } />
            <Route exact path="/config/direcionamentos/entrada" component={ DialPlanEntrance } />
            <Route exact path="/config/direcionamentos/interno" component={ DialPlanInternal } />
            <Route exact path="/config/direcionamentos/externo" component={ DialPlanExternal } />
            <Route exact path="/config/usuarios/novo" component={ CreateUsers } />
            <Route exact path="/config/usuarios/lista" component={ ListUsers } />
            <Route exact path="/config/usuarios/id" component={ ListUserId } />
            <Route exact path="/config/uploads" component={ Uploads } />
            <Route exact path="/config/clientes/novo" component={ Tenants } />
            <Route exact path="/config/clientes/lista" component={ TenantsList } />
            <Route exact path="/config/uploads/lista" component={ UploadsList } />
            <Route exact path="/agenda/lista" component={ ListContacts } />
            <Route exact path="/agenda/novo" component={ NewContact } />
            <Route exact path="/agenda/contato/id" component={ ContactById } />
            <Route exact path="/agenda/contato/visualizar" component={ ContactShowById } />
            <Route exact path="/troubleshooting/sip" component={ LogsVigoscloud } />
            <Route exact path="/troubleshooting/comandos" component={ PingPage } />
          </div>
        </Provider>
      </BrowserRouter>
    );
  }
}

export default App;
